import {HRToolCard} from "components/hr/widgets/HRToolCard";

declare var document:any;
import {UIState} from "data/UIState";
import * as React from "react";
import HRRegisterChart from "components/hr/main/dashboard/HRRegisterChart";
import {observer} from "mobx-react";
import {Helpers} from "data/hr/Helpers";
import './HRDashboard.pcss';
import {Transport} from "data/transport";
import {handleSpacePressed} from "utils";

export const HRDashboard = observer(() => {
/*
  function downloadFile(url) {
    return new Promise((resolve, reject) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.substring(url.lastIndexOf('/') + 1); // Set the filename based on the URL
      link.style.display = 'none';

      document.body.appendChild(link);

      link.addEventListener('click', () => {
        resolve('Download started');
      });

      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
      }, 0);
    });
  }

  function handleDownload(url:string) {
    UIState.loadSpinner("Please wait...", "Your report is being generated. This may take several minutes.");
    downloadFile(Transport.URL(url, true))
      .then(()=>{
        UIState.unloadSpinner();
      })
      .catch(()=>{
        UIState.unloadSpinner();
      })
  }
*/

  async function downloadFile(url: string): Promise<void> {
    const response = await fetch(url, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }

    const blob = await response.blob();

    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = url.substring(url.lastIndexOf('/') + 1);

    const match = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^\";]+)/i);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1].replace(/"/g, ''));
    }

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  }

  async function handleDownload(url: string) {
    UIState.loadSpinner(
      "Please wait...",
      "Your report is being generated. This may take several minutes."
    );

    try {
      await downloadFile(Transport.URL(url, true));
    } finally {
      UIState.unloadSpinner();
    }
  }


  const accountCreationReport = (e) => {
    e.preventDefault();
    handleDownload("/hr/registrationReport");
  }

  const fullAttendanceReport = (e) => {
    e.preventDefault();
    handleDownload("/hr/fullAttendanceReport");
  }

  const pointsReport = (solutionId) => {
    handleDownload("/hr/solutionParticipationReport?solutionId="+solutionId);
  }

  return (
    <div>

      <div>

        {UIState.dashboardData.initialized &&
          <>
            {(UIState.dashboardData.data && UIState.dashboardData.data.participants.length > 0)
              ?
              <>
                <HRToolCard title={"Account Signups"}>
                  <div style={{height: '300px'}}>
                    <HRRegisterChart registrationData={UIState.dashboardData.data.participants}/>
                  </div>
                </HRToolCard>


                <HRToolCard title={"Platform Report"}>
                  <table className={"hr-reports"}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Signup Export</td>
                        <td><a
                          onClick={accountCreationReport}
                          onKeyDown={(e)=>{ handleSpacePressed(e, accountCreationReport);}}
                          href={"#"}
                        ><span className="material-symbols-outlined">download</span></a></td>
                      </tr>
                      <tr>
                        <td>Full Participation Report</td>
                        <td><a
                          onClick={fullAttendanceReport}
                          onKeyDown={(e)=>{ handleSpacePressed(e, fullAttendanceReport);}}
                          href={"#"}
                        ><span className="material-symbols-outlined">download</span></a></td>
                      </tr>

                    </tbody>
                  </table>
                </HRToolCard>


                <HRToolCard title={"Solution Participation Reports"}>
                  <table className={"hr-reports"}>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Visible Date</th>
                        <th>Open Date</th>
                        <th>Close Date</th>
                        <th>Badge</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                    {[...UIState.dashboardData.data.solutions, ...(UIState.dashboardData.data.archivedSolutions || [])].map((solution)=> {
                      const visibleDate = Helpers.standardDate(solution.visibleDate);
                      const openDate = solution.alwaysAvailable ? "Always open" : Helpers.standardDate(solution.openDate);
                      const closeDate = solution.alwaysAvailable ? "" : Helpers.standardDate(solution.closeDate);
                      return (
                        <tr key={solution._id}>
                          <td>{solution.name}{solution.archived ? " (archived)" : ""}</td>
                          <td>{visibleDate}</td>
                          <td>{openDate}</td>
                          <td>{closeDate}</td>
                          <td>{solution.badgeUsed ?"YES":""}</td>
                          <td><a
                            onClick={(e) => {
                              e.preventDefault();
                              pointsReport(solution._id);
                            }}
                            onKeyDown={(e)=>{ handleSpacePressed(e, () => {
                              pointsReport(solution._id);
                            }) }}
                          ><span className="material-symbols-outlined">download</span></a></td>

                        </tr>
                      )

                    })}
                    </tbody>
                  </table>
                </HRToolCard>

              </>
              :
              <p style={{padding: '0 8px'}}>No registrations yet. Please check back.</p>
            }
        </>
        }
      </div>



    </div>
  );
});
